import React from 'react';
import styled from 'styled-components';
import {labels} from '../../../../../util/utils';
import env from '../../../../../util/env';
import EllipsesMoment from '../../../../Common/EllipsesControl/EllipseMoment';
import TextLink from '../../../../Common/BaseComponentWrappers/MotifTextLink';
import {useIsDrawerMode} from '../../../../../util/Ares/customHooks';
import {useEngagementId, useUserPreferences} from '../../../../../util/customHooks';

function Project(props) {
	const engagementId = useEngagementId();
	const userPreferences = useUserPreferences();
	let herculesUrl = env.getURL('hercules_web') + '/connections?engagementid=' + engagementId;
	const isDrawerMode = useIsDrawerMode();
	return (
		<>
			<HelixProjectsList>
				<li>
					<section className="project-name">
						<span className="header">{labels.linkedEYHelixProjects}</span>
						<span className="project-namelbl" title={props.project.projectName}>
							{props.project.projectName}
						</span>
					</section>
					<section className="client-name">
						<span className="header">{labels.client}</span>
						<span title={props.project.clientName}> {props.project.clientName}</span>
					</section>
					<section className="engagement-name">
						<span className="header">{labels.engagement}</span>
						<span title={props.project.engagementName}> {props.project.engagementName}</span>
					</section>
					<section className="analysis-date">
						<span className="header">{labels.analysisDate}</span>
						<EllipsesMoment
							userPreferences={userPreferences}
							date={props.project.analysisEnd}
							fromNow={false}
							useFormat
							useLocal={false}
						/>
					</section>
					{!isDrawerMode && (
						<section className="helixprojects-link">
							{
								<TextLink variant="alt" href={herculesUrl}>
									{labels.eyHelixProjects}
								</TextLink>
							}
						</section>
					)}
				</li>
			</HelixProjectsList>
		</>
	);
}
export default Project;

const HelixProjectsList = styled.ul`
	li {
		span.header {
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			max-width: 97%;
			line-height: normal;
		}
		.header + span {
			font-size: var(--px-14);
			color: var(--neutrals-900);
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			max-width: 97%;
			font-weight: 500;
		}
		.project-name {
			display: inline-block;
			width: 25%;
			span {
				display: block;
			}
			.project-namelbl {
				font-size: var(--px-16);
				font-weight: 400;
				.motif-icon {
					display: inline-block;
					color: var(--green-400);
					margin-right: var(--px-5);
					vertical-align: middle;
					svg {
						width: var(--px-20) !important;
						height: var(--px-20) !important;
						vertical-align: middle;
						margin-top: calc(var(--px-6_5) * -1);
					}
				}
			}
		}
		.client-name {
			display: inline-block;
			width: 25%;
			span {
				display: block;
			}
		}
		.engagement-name {
			display: inline-block;
			width: 25%;
			span {
				display: block;
			}
		}
		.analysis-date {
			display: inline-block;
			width: 12.5%;
			span {
				display: block;
			}
			.ellipses {
				font-size: var(--px-14);
				color: var(--neutrals-900);
				font-weight: 500;
			}
		}
		.helixprojects-link {
			display: inline-flex;
			width: 12.5%;
			span {
				display: block;
			}
			.motif-text-link {
				display: block;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
				margin-left: auto;
			}
		}
	}
`;
